'use client';

import {type ThemeColors, type ThemeColorsVariant} from '#/cms/schemas/theme-colors.schema';
import Select from '#/features/components/Select';
import {useCurrentThemeVariant, useThemeStore} from '#/features/store/themeColorsStore';
import {toTitleCase} from '#/utils/to-title-case';
import {useMemo} from 'react';

export function ColorThemeControl({themeColor}: {themeColor: ThemeColors}) {
  const currentThemeColorVariant = useCurrentThemeVariant();
  const handleThemeChange = ({id}: {id: string}) => {
    useThemeStore.setState({themeColorsVariant: id as ThemeColorsVariant});
  };

  const colorOptions = useMemo(
    () => Object.keys(themeColor).map(themeVariant => ({id: themeVariant, title: toTitleCase(themeVariant)})),
    [themeColor]
  );

  return (
    <Select
      options={colorOptions}
      value={{id: currentThemeColorVariant, title: toTitleCase(currentThemeColorVariant)}}
      title={currentThemeColorVariant}
      onChange={handleThemeChange}
      // make the options open upwards
      optionsStyle={'top-[-200%]'}
    />
  );
}
